export default ({
  namespaced: true,
  state: {
    view: 'automationCreateTask',
    values: {dialog: false, taskId: 0, tasktemplateAutomationIds: []}
    // teste : values: {dialog: true, taskId: 2510040, tasktemplateAutomationIds: [466]}
  },
  getters: {
    dialog: state => {
      return state.values.dialog
    },
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_dialog (state, payload) {
      state.values.dialog = payload
    },
    change_values (state, payload) {
      Object.assign(state.values, payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/automationCreateTask.js